import { LOGOS } from "@/content/landing";

export function LogoStrip() {
  return (
    <section
      data-testid="landing-logos"
      className="relative w-full border-t border-border/60"
    >
      <div className="mx-auto w-full max-w-6xl px-6 py-14">
        <p className="mb-8 text-center font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
          {LOGOS.caption}
        </p>
        <ul className="grid grid-cols-2 items-center gap-x-8 gap-y-6 sm:grid-cols-3 lg:grid-cols-6">
          {LOGOS.items.map((name, i) => (
            <li
              key={name}
              data-testid={`landing-logo-${i}`}
              className="flex items-center justify-center"
            >
              <FakeLogo name={name} variant={i % 3} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function FakeLogo({ name, variant }) {
  // Three subtle, distinguishable greyscale marks so the strip doesn't look
  // like a copy-paste row. All use currentColor → theme-aware.
  const base =
    "inline-flex items-center gap-2 text-muted-foreground/80 transition-colors hover:text-foreground";
  if (variant === 0) {
    return (
      <span className={base}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
          <circle cx="11" cy="11" r="9.5" stroke="currentColor" />
          <circle cx="11" cy="11" r="3.5" fill="currentColor" />
        </svg>
        <span className="font-mono text-sm tracking-tight">{name}</span>
      </span>
    );
  }
  if (variant === 1) {
    return (
      <span className={base}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
          <rect
            x="2"
            y="2"
            width="18"
            height="18"
            rx="3"
            stroke="currentColor"
          />
          <path d="M2 11 H20" stroke="currentColor" />
          <path d="M11 2 V20" stroke="currentColor" />
        </svg>
        <span className="font-mono text-sm tracking-tight">{name}</span>
      </span>
    );
  }
  return (
    <span className={base}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <path
          d="M3 18 L11 4 L19 18 Z"
          stroke="currentColor"
        />
        <circle cx="11" cy="14" r="2.5" fill="currentColor" />
      </svg>
      <span className="font-mono text-sm tracking-tight">{name}</span>
    </span>
  );
}
